<template>
  <div class="layout">
    <HeaderTop></HeaderTop>

    <div class="container" style=" padding: 90px 0 24px;position: relative; overflow: hidden; ">
      <div>
        <div class="side">
          <div class="user">
            <b-avatar :src="user.photo||userPhoto" size="60px"></b-avatar>
            <div class="p-2">
              <span class="text-white " style="color:#333333 !important;font-weight: bold; font-size: 18px;">
                {{ user.name }}
              </span>
            </div>
          </div>
          <ul id="nav" class="nav flex-column text-left">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/home' }"
                :class="{ active: $route.path === '/main/home'||$route.path === '/news'||$route.path === '/newsDetails' }">
                <b-icon-house-door></b-icon-house-door>
                <span class="pl-md-2">主页</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/bmRegister' }"
                :class="{ active:
                $route.path === '/main/bmRegister'||
                $route.path === '/main/mineBmSelectLocation' ||
                $route.path === '/main/mineBmSelectMajor'
                }">
                <b-icon-chat-text></b-icon-chat-text>
                <span class="pl-md-2">报名注册</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/log' }"
                :class="{ active: $route.path === '/main/log'||$route.path === '/main/logDetails' }">
                <b-icon-chat-text></b-icon-chat-text>
                <span class="pl-md-2">我的日志</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="schoolInfo.isOpenStudy">
              <router-link class="nav-link" :to="{ path: '/main/specialtyPlan' }"
                :class="{ active: isSpecialtyPlanActive }">
                <b-icon-file-earmark-ppt></b-icon-file-earmark-ppt>
                <span class="pl-md-2">专业计划</span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/registration' }"
                :class="{ active: $route.path === '/main/registration' }">
                <b-icon-receipt></b-icon-receipt>
                <span class="pl-md-2">综合评价报名</span>
              </router-link>
            </li>

            <li class="nav-item" v-if="schoolInfo.isOpenStudy">
              <router-link class="nav-link" :to="{ path: '/main/course' }"
                :class="{ active: $route.path === '/main/course' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-2">课件学习</span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/evaluation' }"
                :class="{ active: $route.path === '/main/evaluation' }">
                <b-icon-receipt></b-icon-receipt>
                <span class="pl-md-2">知识点测验</span>
              </router-link>
            </li>

            <template v-if="user.isStudyExam">
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/main/homework' }"
                  :class="{ active: $route.path === '/main/homework' }">
                  <b-icon-receipt></b-icon-receipt>
                  <span class="pl-md-2">综合评价作业</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/main/exam' }"
                  :class="{ active: $route.path === '/main/exam' }">
                  <b-icon-brush></b-icon-brush>
                  <span class="pl-md-2">综合评价考试</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/main/score' }"
                  :class="{ active: $route.path === '/main/score' }">
                  <b-icon-card-text></b-icon-card-text>
                  <span class="pl-md-2">综合评价成绩</span>
                </router-link>
              </li>
            </template>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/register' }"
                :class="{ active: $route.path === '/main/register' }">
                <b-icon-arrow-left-right></b-icon-arrow-left-right>
                <span class="pl-md-2">考籍异动</span>
              </router-link>
            </li>

            <template v-if="user.isThesis">
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/main/thesis2' }"
                            :class="{ active: ($route.path === '/main/thesis2'||$route.path === '/main/addThesisProposal'||$route.path === '/main/myThesisProposal'||$route.path === '/main/updateThesisProposal') }">
                  <b-icon-file-person></b-icon-file-person>
                  <span class="pl-md-2">毕业论文</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ path: '/main/onlineDefenseList' }"
                            :class="{ active: ($route.path === '/main/onlineDefenseList') }">
                  <b-icon-file-earmark-text></b-icon-file-earmark-text>
                  <span class="pl-md-2">论文答辩</span>
                </router-link>
              </li>
            </template>

            <li class="nav-item" v-if="user.isThesisDegree">
              <router-link class="nav-link" :to="{ path: '/main/mySpotCheck' }"
                           :class="{ active: $route.path === '/main/mySpotCheck' }">
                <b-icon-award></b-icon-award>
                <span class="pl-md-2">学位论文</span>
              </router-link>
            </li>
            <!-- 旧版实践考核菜单已屏蔽 -->
            <!-- <li class="nav-item" v-if="user.isPractice">
              <router-link class="nav-link" :to="{ path: '/main/mySjkh' }"
                          :class="{ active: ($route.path === '/main/mySjkh') }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-2">实践考核</span>
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/practiceAssessment' }"
                          :class="{ active: $route.path === '/main/practiceAssessment' }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-2">实践考核</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/msg' }"
                :class="{ active: $route.path === '/main/msg'||$route.path === '/main/msgDetails' }">
                <b-icon-chat-text></b-icon-chat-text>
                <span class="pl-md-2">学习提醒</span>
              </router-link>
            </li>
            <li class="nav-item">
              <!-- <router-link class="nav-link" :to="{ path: '/main/info' }"
                :class="{ active: $route.path === '/main/info' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-2">个人信息</span>
              </router-link> -->
              <router-link class="nav-link" :to="{ path: '/main/bmInfo' }"
                :class="{ active: $route.path === '/main/bmInfo' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-2">个人信息</span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/order' }"
                :class="{ active: $route.path === '/main/order' }">
                <b-icon-cart></b-icon-cart>
                <span class="pl-md-2">助学培训费订单</span>
              </router-link>
            </li>

            <li class="nav-item" v-if="user.isStudyExam">
              <router-link class="nav-link" :to="{ path: '/main/order2' }"
                :class="{ active: $route.path === '/main/order2' }">
                <b-icon-cart></b-icon-cart>
                <span class="pl-md-2">试卷订单</span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/editPw' }"
                :class="{ active: $route.path === '/main/editPw' }">
                <b-icon-lock></b-icon-lock>
                <span class="pl-md-2">修改密码</span>
              </router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="logout">
                <b-icon-box-arrow-right></b-icon-box-arrow-right>
                <span class="pl-md-2" style="cursor: pointer;">退出登录</span>
              </a>
            </li>
          </ul>

        </div>
        <div class="view">
          <router-view />
        </div>
      </div>
    </div>


    <Footer></Footer>
    <FightersAgreementDialog
      ref="FightersAgreementDialog"
      @confirm="onPledgeConfirm"
    />
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import FightersAgreementDialog from "./FightersAgreementDialog.vue";
import { mapState } from "vuex"
import store from "@/store";


export default {
  name: "Layout",
  components: {
    HeaderTop,
    Footer,
    FightersAgreementDialog
  },
  data() {
    return {
      loading: false,
      showPassForm: false,
      passwordForm: {
        oldPass: null,
        newPass: null,
        confirmPass: null,
      },
      schoolPhoto: null,
      schoolName: null,
      websiteName: null,
      userPhoto: require(`@/assets/user.png`),
      isRegInfo: true,
      refreshLock: false,
      refreshTime: null,
      isDot: false,
    };
  },
  computed: {
    ...mapState(['user','tenantInfo', 'schoolInfo']),
    isSpecialtyPlanActive() {
      const path = this.$route.path;
      return path === '/main/specialtyPlan'
        || path === '/main/courseDetail'
        || path === '/main/freeStudyPaper'
        || path === '/main/paperResult';
    },
  },
  created() {
    document.body.style.filter = ''
  },
  mounted() {
    this.getConfirmStatus()
  },
  watch: {
    '$route'(to, from) {
      console.log(to, from);
      this.getConfirmStatus(to.path)
    }
  },
  destroyed() {
    clearInterval(this.refreshTime);
  },
  methods: {
    getConfirmStatus(path){
      if(path != '/main/bmInfo'){
        this.$http.get('/student/pc/register/queryStudentInfo').then((res) => {
          if(res.confirmStatus == '0'){
            this.$router.push({ path: '/main/bmInfo' })
          }
        })
      }
    },
    logout() {
      this.$confirm("确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (res == "confirm") {
          this.$store.commit("LOGOUT");
          this.$router.push({ name: "Login" })
        }
      });
    },
    onPledgeConfirm(pledgeData) {

    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  background-repeat: no-repeat;
  background-size: 100% 260px;
  height: 100%;

  .navbar {
    background: url('../assets/home.png');
    height: 100px;
    border-bottom: 6px solid #3A77A8;
  }

  .schoolPhoto {
    height: 2.5rem;
  }
}

.navbar-brand {
  color: #093151;
  font-size: 1.5rem;
}

.user {
  text-align: center;
  padding-top: 20px;

}

.side {
  width: 200px;
  float: left;
  background: #fff;
  box-shadow: 0px 0px 5px 1px rgba(221, 221, 221, 0.5);
  border-radius: 5px;
}

.view {
  margin-left: 200px;
}

#nav {
  padding: 0 16px 16px;

  .b-icon {
    font-size: 16px;
  }

  li {}

  a {
    font-size: 13px;
    color: #333333;
    box-sizing: border-box;
    padding: 10px 25px;
    display: inline-block;
    width: 100%;
    height: 40px;
    margin: 5px auto;
    border-radius: 20px;
  }

  .nav-link.active {
    color: #fff;
    background-color: #0065BA;
  }
}
</style>
